// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__tfIQ6","title":"AfterBackImages_title__V72Qm","images":"AfterBackImages_images__BI8yK"};